import React from "react"
import { useNavigate } from "react-router-dom"
import { classNames } from "../../utils"
import { LucideIcon } from "lucide-react"

interface Item {
  current: boolean
  name: string
  href?: string
  icon: LucideIcon
  onClick?: () => void
}

interface Props {
  isFull: boolean
  item: Item
}

const NavbarItem: React.FC<Props> = ({
  isFull,
  item: { name, href, current, icon: Icon, onClick }
}) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      return onClick()
    }

    if (href) {
      navigate(href)
    }
  }

  return (
    <div
      className={classNames(
        current
          ? "bg-white/[.1] text-white"
          : "text-white/[.6] hover:bg-white/[.1] hover:text-white",
        isFull ? "justify-start" : "justify-center",
        "group flex items-center px-2 py-2 text-sm font-medium rounded-md cursor-pointer whitespace-nowrap overflow-hidden select-none transition-colors"
      )}
      onClick={handleClick}
      title={!isFull ? name : undefined}
    >
      <Icon
        className={classNames(
          current ? "text-white" : "text-white/[.6] group-hover:text-white",
          isFull ? "mr-3" : "mr-0",
          "flex-shrink-0 transition-colors"
        )}
        size="20"
        aria-hidden="true"
      />
      {isFull ? name : ""}
    </div>
  )
}

export default NavbarItem
